exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination{\r\n\tmargin: 10px;\r\n}\r\n\r\n.pagination button{\r\n\tborder: 1px solid #ccc;\r\n\tbackground: #FFF;\r\n\tborder-radius: 0px;\r\n\tcolor: #999;\r\n\tmargin: 0 2px;\r\n}\r\n\r\n.pagination button:hover{\r\n\tbackground: #ddd;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader/lib!./src/app/style/react-paginating.css
// module id = 366
// module chunks = 0